<div class="icd-search-container">
  <input type="text"  class="search form-control" [(ngModel)]="currentData.filterKey" [attr.placeholder]="'field.hint.search' | translate | async"  (keydown.enter)="handleKeyEnter($event)">
  <i class="fa fa-search icd-icons icd-search-icon" (click)="handleKeyEnter('')" aria-hidden="true"></i>
  <i class="fa fa-sort icd-icons icd-toggle-icon" (click)="toggleSearchBox()" aria-hidden="true"></i>
</div>
<!-- <input type="text"  class="search form-control" [attr.placeholder]="'field.hint.search' | translate | async"  (keydown.enter)="handleKeyEnter($event)"> -->
<!-- [triggered]="currentData.triggered" (clickOutside)="displaySearch($event)" -->
@if (currentData.searchData && currentData.show) {
  <div  [innerHTML]="currentData.searchData | safeStyleHtml"></div>
}
@if (currentData.show_sections) {
  <div class="icd-list-container">
    @if (currentData.rootData) {
      @for (cd of currentData.rootData; track cd) {
        <div>
          <div class="_icd-search-items">
            <i class="fa fa-caret-right" aria-hidden="true" (click)="getChild(cd)"></i>
            <div [innerHtml]="cd.html"(click)="selectChild(cd)" class="parent parent_{{cd.ID}}"></div>
          </div>
          @if (cd.child) {
            <ng-container
              *ngTemplateOutlet="Recursion; context:{ list: cd.child}"
            ></ng-container>
          }
        </div>
      }
    }
  </div>
}
@if (currentData.selectedData && currentData.selectedData.length > 0) {
  <div class="popup-floating-bar">
    <div class="popup-floating-button">
      <button type="button" (click)="submitBtn()" style="text-align: center;" class="primary-btn"><span>{{'button.submit' | translate | async}}</span>
      <i class="fa fa-plus-square" aria-hidden="true"></i>
    </button>
  </div>
</div>
}


<ng-template #Recursion let-list="list">
  @for (item of list; track item) {
    <div [hidden]="item.selectedNode != undefined && item.selectedNode == false" class="_icd-search-items" [ngStyle]="{'padding-left': item.padding+'px'}">
      @if (!item.isLeaf) {
        <i class="fa fa-caret-right" aria-hidden="true" (click)="getChild(item)"></i>
      }
      <div [innerHtml]="item.html" [ngClass]="{'selected' : item.selected, 'last_child_' : item.isLeaf ,'selected_node': 'item.selectedNode'}" (click)="selectChild(item)" class="child-parent parent_{{item.parentId}}"></div>
    </div>
    @if (item.child && item.child.length > 0) {
      <ng-container
        *ngTemplateOutlet="Recursion; context:{ list: item.child }"
      ></ng-container>
    }
  }
</ng-template>